var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.listaLoja,"item-text":"nmLoja","item-value":"cdLoja","label":"Loja","outlined":"","autofocus":_vm.autofocus,"readonly":_vm.readonly,"hide-details":"","dense":_vm.dense},on:{"change":_vm.onSelect},model:{value:(_vm.cdLoja),callback:function ($$v) {_vm.cdLoja=$$v},expression:"cdLoja"}})
}
var staticRenderFns = []

export { render, staticRenderFns }